module.exports = __webpack_public_path__ + "img/oabat_logo.50734f5.jpg";